import React from 'react'

export default React.createContext({
  storeData: {},
  updateStoreData: (e) => {},
})
